import { render } from "./FAQView.vue?vue&type=template&id=59646356&ts=true"
import script from "./FAQView.vue?vue&type=script&lang=ts"
export * from "./FAQView.vue?vue&type=script&lang=ts"

import "./FAQView.vue?vue&type=style&index=0&id=59646356&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__